import { render, staticRenderFns } from "./StemdoerDetailPage.vue?vue&type=template&id=52c59e56"
import script from "./stemdoerDetailPage.ts?vue&type=script&lang=ts&external"
export * from "./stemdoerDetailPage.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports